<template>
    <Slide right :isOpen="isOpen" @closeMenu="closeMenu()" :burgerIcon="false" noOverlay>
        <div class="mm-menu">
            <Menus :isMobile="true" @close="closeMenu()" @open="openBuscador()"/>
        </div>
    </Slide>
    <div id="page-wrap">
        <div class="wrapper">
            <header class="menu-principal-wrapper">
                <nav class="navbar navbar-expand-lg">
                    <Link href="/" class="navbar-brand">
                    <img loading="lazy" width="355" height="133" src="/img/logo-santiago.png" alt="Gobierno de Santiago Nuevo Léon">
                    </Link>
                    <div class="container-fluid">
                        <a id="button-open-menu-mobile" class="mburger mburger--spin" @click="openMenu()">
                            <b></b>
                            <b></b>
                            <b></b>
                        </a>
                        <div class="menu-principal navbar-collapse collapse" id="navmenu">
                            <Menus :isMobile="false" @open="openBuscador()"/>
                        </div>
                    </div>
                </nav>
            </header>
            <slot />
        </div>
        <Footer />
        <BuscadorModal :isOpen="buscadorOpen" @close="closeBuscador()"/>
    </div>
</template>
<script>
import Menus from "./Menus.vue";
import Footer from "./Footer.vue";
import BuscadorModal from "./BuscadorModal.vue";
import { Slide } from 'vue3-burger-menu';
import { Link } from '@inertiajs/inertia-vue3';

export default {
    data() {
        return {
            isOpen: false,
            buscadorOpen: false,
        };
    },
  components: {
    Footer, BuscadorModal, Menus, Slide, Link
  },
  methods:{
    closeMenu(){
        this.isOpen = false;
    },
    openMenu(){
        this.isOpen = true;
    },
    closeBuscador(){
        this.buscadorOpen = false;
    },
    openBuscador(){
        this.buscadorOpen = true;
    },
  }
}
</script>
<style>
a{
    text-decoration: none !important;
}
.mm-listview{
    width: 100%;
}
.bm-item-list{
    color: inherit;
    margin-left: 0;
    font-size: inherit;
}
.bm-item-list>*{
    padding: 0;
}
.bm-menu{
    background-color: #fff !important;
    box-shadow: rgba(92, 32, 32, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;
}
.mm-menu{
    top: 60px;
    width: 300px;
    background-color: #fff !important;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.bm-cross-button {
    zoom: 1.3;
}
.bm-cross {
    background: #595959;
}
.menu-principal-item ul{
    z-index: 2 !important;
}
.submenu > a:hover + div ul, .submenu > a + div:hover ul, .submenu a + div:focus ul {
    opacity: 1;
    transform: translateY(0);
    visibility: visible;
    z-index: 2;
}
.active.menu-principal-item .mm-listitem__text{
    color: #B29966;
}
.submenuMobile ul{
    top: 0;
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
    z-index: 1;
    transition: none;
    box-shadow: none;
    right: initial !important;
}
.mm-btn.active::after{
    transform: rotate(225deg);
    color: #B29966;
}
.submenuMobile ul a{
    transition: none;
}
.openMenu {
    position: relative;
    width: 100%;
    border-top: 1px solid #333;
    border-bottom: 1px solid #333;
    top: 1px;
}
.openMenu ul {
    position: relative;
}
.openMenu a {
    margin-left:20px;
}


.btn-close {
    --bs-btn-close-color: #000;
    --bs-btn-close-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e");
    --bs-btn-close-opacity: 0.5;
    --bs-btn-close-hover-opacity: 0.75;
    --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
    --bs-btn-close-focus-opacity: 1;
    --bs-btn-close-disabled-opacity: 0.25;
    --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
    box-sizing: content-box;
    width: 1em;
    height: 1em;
    padding: 0.25em 0.25em;
    color: var(--bs-btn-close-color);
    background: transparent var(--bs-btn-close-bg) center / 1em auto no-repeat;
    border: 0;
    border-radius: 0.375rem;
    opacity: var(--bs-btn-close-opacity);
    padding: calc(var(--bs-modal-header-padding-y)* 0.5) calc(var(--bs-modal-header-padding-x)* 0.5);
    margin: calc(-0.5* var(--bs-modal-header-padding-y)) calc(-0.5* var(--bs-modal-header-padding-x)) calc(-0.5* var(--bs-modal-header-padding-y)) auto;

}

</style>
